import {ErreurModel} from './erreur.model';


export class BaseModel {
	message:		string;
	traitementOk:	boolean = true;

	// Edit
	_isEditMode: boolean = false;
	// Log
	_userId: number = 0; // Admin
	_createdDate: string;
	_updatedDate: string;


	// Erreur
	_erreur: ErreurModel;
}
